<template>
    <div class="container pb-4 mb-4">

      <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>

<div v-else>

<div class="row">
<div class="col d-md-none d-none d-md-table pb-3">
  <h5>{{campaign.name}}</h5>
  <i v-if="campaign.status == 'Active'" class="fas fa-circle pr-2" style="color:green" :title="campaign.status"></i>
  <i v-else class="fas fa-circle pr-2" style="color:red" :title="campaign.status"></i>
  <small>
  <a :href="campaign.url" target="_blank">{{campaign.url.replace(/^https?:\/\//, '')}}</a>
  <span v-if="campaign.status == 'Active'"><span class="px-2">&bull;</span> 
  <a :href="`/?campaign_id=${campaign.id}`" target="_blank">Preview</a></span>
  </small>
  </div>
<div class="col text-right">
  <div><a href="/advertising"><i class="fa-solid fa-arrow-left pr-2"></i>Back</a></div>
  <div class="pt-3"><small>
    <a :href="`/campaigns/new?edit=true&campaign_id=${campaign.id}`">Edit campaign</a> <span class="px-2">&bull;</span> 
    <a href="#/" @click="showModalCampaignStatus(campaign)" title="Update status">{{statusText}}</a> <span class="px-2">&bull;</span> 
    <a href="#/" @click="showModalDeleteCampaign(campaign)">Delete campaign</a>
    </small></div>
</div>
</div>

  <div class="card">
    <div class="card-body">

      

      <div v-if="adverts.length == 0" class="text-center py-1">
            <a href="/adverts/new" class="btn btn-success">Create Advert</a>
        </div>

        <div v-else>

          <div class="text-center pb-3">
            <select class="date-range" v-model="filter" @change="getCampaign()">
                <option v-for="(status, index) in statuses" :key="index" :value="status">{{status}}</option>
            </select>
            <span v-if="loadingFilter" class="date-range-text"><i class="fas fa-spinner fa-spin"></i></span>
            <span v-else-if="rangeText" class="date-range-text">{{rangeText}}</span>
          </div>

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="22%">Advert</th>
                  <th class="pl-3" width="20%">Views</th>
                  <th class="pl-3" width="20%">Clicks</th>
                  <th class="pl-3" width="20%">Click Rate</th>
                  <th class="first-right pl-3" width="18%">Action</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(advert, index) in adverts" :key="index.id">
              <td class="pl-3">
                <a :href="advert.image" target="_blank">{{advert.orientation}}</a>
              </td>
              <td class="pl-3">{{advert.views}}</td>
              <td class="pl-3">{{advert.clicks}}</td>        
              <td class="pl-3">{{calculateRate(advert.clicks,advert.views)}}</td>
              <td class="pl-3">
                <a :href="`/adverts/view/${advert.id}`" class="mr-3" title="View stats"><i class="fas fa-chart-line"></i></a>
              </td>          
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Advert • Views • Clicks</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body" v-for="(advert, index) in adverts" :key="index">
  
        <td class="pl-2 text-center">
            <div><img :src="advert.image" class="img-fluid banner"></div>
            <div class="pt-2">{{advert.target}}</div>
            <div>Views: {{advert.views}}</div>
            <div>Clicks: {{advert.clicks}}</div>
            <div>Click Rate: {{calculateRate(advert.clicks,advert.views)}}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
  </div>
  <campaign-status :campaign="campaign"></campaign-status>
  <delete-campaign :campaign="campaign" ref="DeleteCampaign"></delete-campaign>
  </div>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['campaign_id'],

  data() {
    return {
      adverts: [],
      campaign: {},
      loading: true,
      statusText: 'Activate campaign',
      rangeTest: null,
      filter: 'Today',
      statuses: ['Today', 'Yesterday','This week','Last week','This month','Last month','This year','Last year','All time'],
      loadingFilter: false,
    };
  },

  watch: {
    'campaign.status': function (newValue) {
      if (newValue == 'Active') {
        this.statusText = 'Deactivate campaign';
      } else {
        this.statusText = 'Activate campaign';
      }
    },
  },

  created() {
    this.getCampaign();

    EventBus.$on('advert-status-updated', () => {
      this.getCampaign();
    });
  },

  methods: {

    showModalDeleteCampaign() {
      this.$refs.DeleteCampaign.clearContent();
      this.$bvModal.show(`bv-modal-delete-campaign`);
    },
    
    showModalCampaignStatus() {
      this.$bvModal.show(`bv-modal-campaign-status`);
    },

    getCampaign() {

      this.loadingFilter = true;

      axios.post(`/campaigns/fetch`, {
        filter: this.filter,
        campaign_id: this.campaign_id,
      }).
      then((response) => {
        this.campaign = response.data.campaign;
        this.adverts = response.data.adverts;
        this.rangeText = response.data.rangeText;
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
      }).finally(() => {
        this.loading = false;
        this.loadingFilter = false;
      });

    },

  },
};
</script>